var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.isUserLogged)?_c('UserLoginRegisterVue'):_vm._e(),(_vm.isUserLogged)?_c('button',{staticClass:"mlrAccountDeletion button btn_purple",on:{"click":_vm.confirmDeletion}},[_vm._v("Delete My Account")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }